export const AUTH_LABELS = {
  signUp: 'sign up',
  signIn: 'sign in',
};
  
export const ERROR_MESSAGES = {
  GENERIC: 'Please try again or use another method to',
};